/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export type { Erc20 } from "./Erc20";
export * as factories from "./factories";
export { Erc20__factory } from "./factories/Erc20__factory";
